import React from "react";
import CustomeButton from "../Button";
import fileUploadLogo from "../../assets/attachment-paperclip.svg";
import FileUploadModal from "../Processes/conversations/FileUploadModal";
import OfficerRegistered from "./OfficerRegistered";
import useAddAttachments from "./useAddAttachments";
import DocumentTable from "~/components/document-table/DocumentTable";
import { formatDate } from "~/utils/CSVFunctions";
import { mergeCategories } from "~/Pages/Requests/components/new-request-modal/utils";

const mapFilesToDocumentRows = (files: { file: Record<string, unknown> }[]) =>
  (files || []).map((item) => {
    const f = item.file;
    const subCategoryCode =
      typeof f?.subcategory === "object"
        ? (f?.subcategory as { code?: string })?.code
        : f?.subcategory;
    return {
      name: (f?.fileName as string) || (f?.name as string),
      description: (f?.description as string) ?? "",
      category: f?.category,
      subCategory: subCategoryCode,
      subcategoryName: f?.subcategoryName as string | undefined,
      fileYearMonth: f?.fileYearMonth as
        | { year: number; month: number }
        | undefined,
      year: (f?.year ??
        (f?.fileYearMonth as { year?: number })?.year ??
        f?.customYear) as number | string | undefined,
      month: (f?.month ?? (f?.fileYearMonth as { month?: number })?.month) as
        | number
        | undefined,
      blob_url: f?.objectURL as string | undefined,
      createdAt: (f?.lastModified as string) || new Date().toISOString(),
      file_type: f?.type as string | undefined,
      _original: item,
    };
  });

const AddAttachments = ({
  isCongrats,
  setIsCongrats,
  files,
  setFiles,
  entityData,
  type,
  setActiveIndex,
  resetRegData,
  regData,
}) => {
  const {
    showUploadModal,
    setShowUploadModal,
    fileSupported,
    uploadFileHandler,
    getType,
    downloadFileHandler,
    handleDelete,
    officerAttachmentConfig,
    role,
  } = useAddAttachments(files, setFiles, type, regData);
  return (
    <>
      {!isCongrats ? (
        <div className="formgrid grid">
          <div className="w-full flex justify-content-between mb-4">
            <div>
              <p className="add-new-entity-heading mb-2">Attachments</p>
              <p className="input-label m-0">
                {officerAttachmentConfig?.attachmentDescription}
              </p>
            </div>
            <div className="btns-container flex align-items-center">
              <CustomeButton
                label="Upload File"
                icon="pi pi-upload"
                iconPos="right"
                onClick={() => setShowUploadModal(true)}
              />
            </div>
          </div>
          {files.length === 0 && (
            <div className="no-documents-uploaded-section w-full">
              <img
                src={fileUploadLogo}
                alt="file-upload"
                className="file-upload-logo"
              />
              <p className="add-new-entity-heading mb-0">
                No Documents uploaded yet
              </p>
              <p className="drag-drop-text m-0">
                {officerAttachmentConfig?.noDocUploadedDescription}
              </p>
              <CustomeButton
                label="Upload File"
                icon="pi pi-upload"
                iconPos="right"
                onClick={() => setShowUploadModal(true)}
              />
            </div>
          )}
          {files.length > 0 && (
            <DocumentTable
              value={mapFilesToDocumentRows(files)}
              formatDate={formatDate}
              onDelete={(row: { _original: (typeof files)[0] }) =>
                handleDelete(row._original)
              }
              onDownload={(row: { _original: (typeof files)[0] }) =>
                downloadFileHandler(row._original?.file)
              }
              hideDetailsSidebar
              emptyMessage="No attachments found"
            />
          )}
        </div>
      ) : (
        <OfficerRegistered
          setActiveIndex={setActiveIndex}
          resetRegData={resetRegData}
          setIsCongrats={setIsCongrats}
          type={type}
        />
      )}
      <FileUploadModal
        entitydata={entityData}
        showModal={showUploadModal}
        fileSupported={fileSupported}
        hideUploadModal={() => setShowUploadModal(false)}
        setUploadedFile={uploadFileHandler}
        getService={getType}
        placeholder={"Choose a file to upload"}
        relatedType={"OFFICER_ONBOARDING"}
        uploadedFile={files}
        categories={mergeCategories(["Entities +"], role)}
      />
    </>
  );
};

export default AddAttachments;
